import React from 'react';
import { IAvailableServiceTimeDay } from 'src/services/api/UserManagement/apiContracts';
import LoadingButton from 'src/components/BulkOperations/_Shared/BulkActionButton/LoadingButton';
import Callout from 'src/components/InformationCallout/Callout';
import ServiceRequestTimeslotPicker from 'src/pages/ServiceRequest/components/ServiceRequestTimeslotPicker/ServiceRequestTimeslotPicker';
import TimeslotPickerSkeleton from 'src/pages/ServiceRequest/components/ServiceRequestTimeslotPicker/TimeslotPickerSkeleton';
import './manual-scheduling-panel.scss';

interface ManualSchedulingPanelProps {
  hasPreferredTimes: boolean;
  availableServiceTimes: IAvailableServiceTimeDay[];
  isLoadingAvailability: boolean;
  isScheduling: boolean;
  scheduledAt: any | null;
  onScheduledAtChange: (scheduledAt: any) => void;
  onScheduleClick: () => Promise<void>;
}

const ManualSchedulingPanel = ({
  hasPreferredTimes,
  availableServiceTimes,
  isLoadingAvailability,
  isScheduling,
  scheduledAt,
  onScheduledAtChange,
  onScheduleClick,
}: ManualSchedulingPanelProps) => {
  if (!hasPreferredTimes) {
    return (
      <div className="manual-scheduling-panel">
        <Callout
          variant="error"
          title="We couldn't load scheduling times"
          subtitle="It doesn't look like there are any valid time slots to schedule for this request. If this doesn't look right, please contact support."
        />
      </div>
    );
  }

  return (
    <div className="manual-scheduling-panel">
      <div className="manual-scheduling-picker">
        {isLoadingAvailability && <TimeslotPickerSkeleton />}
        {!isLoadingAvailability && (
          <ServiceRequestTimeslotPicker
            availableServiceTimes={availableServiceTimes}
            setFormData={(formData: any) =>
              onScheduledAtChange(formData?.scheduledAt)
            }
          />
        )}
      </div>
      <div className="manual-scheduling-action">
        <LoadingButton
          actionText="Schedule"
          isSubmitting={isScheduling}
          disabled={!scheduledAt || isScheduling}
          onClick={() => void onScheduleClick()}
          size="small"
        />
      </div>
    </div>
  );
};

export default ManualSchedulingPanel;
